import type { ReactNode } from 'react';
import { Group, ActionIcon, Tooltip, type TooltipProps } from '@mantine/core';

/** Строка тулбара как в WebmOpusRecorder и AudioPlayer (единая сетка панели). */
export function MediaToolbarRow({ children }: { children: ReactNode }) {
  return (
    <Group align='center' wrap='nowrap' justify='space-between' gap={16}>
      {children}
    </Group>
  );
}

export function MediaToolbarIcon({
  label,
  onClick,
  disabled,
  children,
  position = 'top',
}: {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  children: ReactNode;
  position?: TooltipProps['position'];
}) {
  return (
    <Tooltip
      label={label}
      position={position}
      withArrow
      bg='secondary.2'
      c='primary.7'
    >
      <ActionIcon
        variant='transparent'
        color='secondary'
        size={38}
        aria-label={label}
        disabled={disabled}
        onClick={onClick}
      >
        {children}
      </ActionIcon>
    </Tooltip>
  );
}
